/*
 * @author:      冯炎
 * @update:      20171201
 * @description:
 * */

/************  基础组件  *************/
import React, {Component} from 'react';
import {Row, Col, Icon, Select, Modal, Dropdown, Menu} from 'jcloudui';

/************  自定义组件  *************/

export default class ShopList extends Component{
  constructor(props){
    super(props);
  }
  render(){
    return(
      <div>

      </div>
    )
  }
}